//import Util         from '../lib/util.js';
import * as numeral from 'numeral';
import dayjs from 'dayjs';

export function formatDate(date, format = 'YYYY-MM-DD') {
  let m: any = dayjs(date);
  //format = format || 'YYYY-MM-DD HH:mm:ss';
  if (date !== undefined && date !== null && m.isValid()) {
    return m.format(format);
  } else {
    return '';
  }
}

export function formatDateTime(date) {
  return formatDate(date, 'YYYY-MM-DD HH:mm:ss');
}

export function formatNumber(n, format: any = '3') {
  if (n === undefined) {
    //后台处理价格权限时，会过滤掉相应的价格、金额字段
    return '***';
  } else if (n === null) {
    return '';
  }

  //处理参数格式
  let formatVal = '',
    formatType = 0; //是否隐藏小数点末尾的0，0不隐藏；1隐藏
  if (typeof format === 'object') {
    formatVal = format.decimalPlaceValue || '';
    formatType = format.decimalPlaceType;
  } else if (typeof format === 'number') {
    formatVal = String(format);
  } else {
    formatVal = format;
  }

  if (!formatVal.includes('.')) {
    let _format = Number(formatVal);
    if (_format > 0) {
      let r = '';
      for (let i = 0; i < _format; i++) {
        r += '0';
      }
      formatVal = '0,0.' + r;
    } else {
      formatVal = '0,0';
    }
  }
  let v = numeral(n).format(formatVal);
  //隐藏小数点末尾的0
  if (formatType === 1) {
    v = transformDecimal(v);
  }
  return v;
}

//格式化小数部分的值
function transformDecimal(val) {
  let arr = val.split('.'),
    decimal = '';
  if (arr.length > 1) {
    decimal = '0.' + arr[1];
    decimal = String(parseFloat(decimal));
    decimal = decimal.substring(2);
  }
  if (decimal === '') {
    return arr[0];
  }
  return arr[0] + '.' + decimal;
}
